export enum NotFoundLocalizationId {
    ErrorTitle = "error-404.error_title",
    ErrorUnauthorizedDescription = "error-404.error_unauthorized_description",
    LoginLink = "error-404.login_link",
    SignupLink = "error-404.sign_up_link",
    OrText = "error-404.or_text",
    Image = "error-404.error_image",
}
